import { useReserveModal } from '@/hooks/useReserveModal';

import { ReserveModal } from '@/components/reserve/Reserve/ReserveModal';
import SafeReserveEditModal from '@/components/reserve/SafeReserveEditModal';
import { ReservationCancel } from '@/components/reserve/ReservationCancel/ReservationCancel';
import { useDashboardFilters } from '@/contexts/DashboardStateContext';

export const ReservationModals = () => {
  const { selectedEvent, setSelectedEvent } = useDashboardFilters();

  const {
    reserveModalData,
    setReserveModalData,
    editModalData,
    setEditModalData,
    cancelModalData,
    setCancelModalData
  } = useReserveModal();

  const selectedEventIsInCancelModal = cancelModalData?.schedules.find(
    (schedule) => schedule.id === selectedEvent?.id
  );

  return (
    <>
      {!!reserveModalData?.resourceType && (
        <ReserveModal
          {...reserveModalData}
          onClose={() => setReserveModalData(null)}
        />
      )}

      {editModalData && (
        <SafeReserveEditModal
          editModal={editModalData.editModal}
          toggleModal={() => setEditModalData(null)}
          schedule={editModalData.schedule}
          canRespondCancel={editModalData.canRespondCancel}
          respondCancel={() => {
            setEditModalData(null);
            if (editModalData.schedule) {
              setCancelModalData({
                open: true,
                schedules: [editModalData.schedule]
              });
            }
          }}
        />
      )}

      {cancelModalData && (
        <ReservationCancel
          schedules={cancelModalData.schedules}
          open={cancelModalData.open}
          setOpen={(isOpen) => {
            if (!isOpen) {
              setCancelModalData(null);
            } else {
              setCancelModalData({
                ...cancelModalData,
                open: true
              });
            }
          }}
          onCancelSuccess={() => {
            if (selectedEventIsInCancelModal) {
              setSelectedEvent(null);
            }
          }}
        />
      )}
    </>
  );
};
